import React from 'react';
import VideoPlayer from "../layout/ReactPlayer";
import {NavLink} from "react-router-dom";
import ThreePhoneCommonMainAction from './ThreePhoneCommonMainAction';
import TwoPhoneSection from './TwoPhoneSection';
import TeeRating from './TeeRating';
import Usp from './Usp';
import HowItWork from './HowItWork';
const ForPlayer = () => {
    return (
        <>

          <div className="">
          <HowItWork/>

          
            <TwoPhoneSection
                heading={"RESOLVE SLOW PLAY WITH TIMELY GOLF"}
                show_btn={true}
                className={""}
                btnLayout={
                    <div className="home__section2__right__btn">
                        <NavLink to="/club-detail" target="_self" className="res-btn-primary">SIGN UP</NavLink>
                        <NavLink to="/contact" target="_self" className={"res-btn-secondary"}>CONTACT US</NavLink>
                    </div>
                }
            />
            <TwoPhoneSection
                heading={"DIGITAL SCORE LOGGING AND GAME HISTORY"}
                show_btn={true}
                className={"reverse"}
                btnLayout={<div className="home__section2__right__btn">
                    <NavLink to="/club-detail" target="_self" className="res-btn-primary">SIGN UP</NavLink>
                    <NavLink to="/contact" target="_self" className={"res-btn-ternary"}>CONTACT US</NavLink>
                </div>}
            />
            <ThreePhoneCommonMainAction
                heading={<span>REVOLUTIONARY <br/> GOLFING APP</span>}
                imgSrc={require("../../assets/images/pages/home/section_1/home_hero_section.svg").default}
                show_subHeading={true}
            />
            <TeeRating />
            <Usp />
          </div>

        </>
    );
};

export default ForPlayer;
